import React, { useState } from 'react';
import { TextField, InputAdornment, IconButton } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';

export default function ServiceApiKeyField({
  value,
  onChange,
  disabled = false,
  label = 'API Key',
}) {
  const [key_visible, setKeyVisible] = useState(false);

  const toggleKeyVisible = () => {
    setKeyVisible((prev) => !prev);
  };

  return (
    <TextField
      label={label}
      type={key_visible ? 'text' : 'password'}
      value={value || ''}
      onChange={(e) => onChange(e.target.value)}
      fullWidth
      disabled={disabled}
      autoComplete='new-password'
      InputProps={{
        endAdornment: (
          <InputAdornment position='end'>
            <IconButton
              aria-label={key_visible ? 'Hide API key' : 'Show API key'}
              onClick={toggleKeyVisible}
              edge='end'
              disabled={disabled}
              tabIndex={-1}
            >
              {key_visible ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
}
